/**
 * Leviathan Web - Dashboard Store
 * Quasar Prime LLC
 *
 * Zustand store for customizable dashboard layout and widget state
 */

import { create } from 'zustand';

export interface LayoutItem {
  i: string;
  x: number;
  y: number;
  w: number;
  h: number;
  minW?: number;
  minH?: number;
}

export interface WidgetConfig {
  id: string;
  visible: boolean;
}

interface DashboardState {
  layout: LayoutItem[];
  widgets: WidgetConfig[];
  isEditing: boolean;
  setLayout: (layout: LayoutItem[]) => void;
  toggleWidget: (widgetId: string) => void;
  setEditing: (editing: boolean) => void;
  setConfig: (layout: LayoutItem[], widgets: WidgetConfig[]) => void;
}

export const useDashboardStore = create<DashboardState>((set) => ({
  layout: [],
  widgets: [],
  isEditing: false,

  setLayout: (layout) => set({ layout }),

  toggleWidget: (widgetId) =>
    set((state) => ({
      widgets: state.widgets.map((w) =>
        w.id === widgetId ? { ...w, visible: !w.visible } : w
      ),
    })),

  setEditing: (isEditing) => set({ isEditing }),

  setConfig: (layout, widgets) => set({ layout, widgets }),
}));
